/**
 * Utility functions for displaying browser notifications
 */

let notificationIdCounter = 0;

export const showBrowserNotification = (notificationData) => {
  const { message, type, requestId } = notificationData;

  // Check if notifications are supported and permitted
  if (!('Notification' in window)) {
    return null;
  }

  if (Notification.permission !== 'granted') {
    return null;
  }

  // Don't show notification if tab is focused (user preference)
  const shouldShow = !document.hasFocus();
  if (!shouldShow) {
    return null;
  }

  // Create notification title based on type
  const title = 'tenantBridge';
  
  // Create notification options
  const options = {
    body: message,
    icon: '/logo192.png',
    tag: `${type}-${requestId}`, // Prevent duplicate notifications
    badge: '/logo192.png',
    requireInteraction: false,
    silent: false
  };

  try {
    const notification = new Notification(title, options);

    // Handle notification click - just focus the window
    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    // Auto-close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    return notification;
  } catch (error) {
    console.error('Error showing browser notification:', error);
    return null;
  }
};

export const closeNotification = (notification) => {
  if (notification) {
    notification.close();
  }
};

